import { render, staticRenderFns } from "./EmpList.vue?vue&type=template&id=6ad47490&scoped=true&"
import script from "./EmpList.vue?vue&type=script&lang=js&"
export * from "./EmpList.vue?vue&type=script&lang=js&"
import style0 from "./EmpList.vue?vue&type=style&index=0&id=6ad47490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad47490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad47490')) {
      api.createRecord('6ad47490', component.options)
    } else {
      api.reload('6ad47490', component.options)
    }
    module.hot.accept("./EmpList.vue?vue&type=template&id=6ad47490&scoped=true&", function () {
      api.rerender('6ad47490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/EmpList.vue"
export default component.exports